import { render, staticRenderFns } from "./DeliveryCenter.vue?vue&type=template&id=727570a9&"
import script from "./DeliveryCenter.vue?vue&type=script&lang=js&"
export * from "./DeliveryCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports